import { ref, readonly } from "vue";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import { useAuthStore } from "@/stores/auth.js";
import { useGlobalLoading } from "@/stores/loading.js";
import axios from "@/utils/axiosInstance";

export function useAxios() {
  const router = useRouter();
  const toast = useToast();
  const authStore = useAuthStore();
  const { startLoading, stopLoading } = useGlobalLoading();

  const results = ref(null);
  const error = ref(null);

  const makeRequest = async (
    method,
    params,
    url,
    redirect = "",
    showSuccessMessage = false,
    settings = "",
    reloadTable = false,
    showErrorMessage = true,
    showLoading = false
  ) => {
    results.value = null;
    error.value = null;

    if (showLoading) {
      console.log("Loading started");
      startLoading();
    }

    try {
      const response = await axios({
        method,
        url,
        data: params,
        settings,
        headers: {
          Authorization: `Bearer ${authStore.token}`,
        },
      });

      const { status, data: responseData } = response;

      if ([200, 201].includes(status)) {
        results.value = responseData;

        if (showSuccessMessage && responseData.message) {
          if (showLoading) stopLoading();
          await swal.fire({
            icon: "success",
            text: responseData.message,
            confirmButtonText: "OK",
          });

          if (redirect) {
            router.push({
              name: redirect,
              query: { reload: reloadTable },
            });
          }
        }
      }

      if (status === 204 && showErrorMessage) {
        await swal.fire({
          icon: "error",
          title: "Error 204",
          text: "Registro no encontrado",
          allowOutsideClick: false,
          allowEscapeKey: false,
          width: 330,
        });

        if (redirect) {
          router.push({ name: redirect });
        }
      }
    } catch (e) {
      error.value = e;
      const { response } = e;
      console.log(e)
      if (!response) {
        if (showErrorMessage) {
          swal.fire({
            icon: "error",
            title: "Error de red",
            text: "No se pudo conectar con el servidor",
          });
        }
        return;
      }

      const { status, data } = response;

      if (!showErrorMessage) {
        return;
      }

      if (status === 422 && data?.errors) {
      
        Object.values(data.errors)
          .flat()
          .forEach((msg) => {
            toast.error(msg, { timeout: 6000 });
          });
      } else if (status === 403) {
        router.push({ name: "NoAutorizado" }); // <- Asegúrate de que esta ruta existe en tu vue-router
      } else {
        swal
          .fire({
            icon: "error",
            title: `Error ${status}`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            text: data?.message || "Ha ocurrido un error",
            width: 330,
          })
          .then((result) => {
            if (result.isConfirmed) {
              if (redirect && redirect != "") {
                // router.push({ name: redirect });
              }
            }
          });
      }
    } finally {
      if (showLoading) stopLoading();
    }
  };

  return {
    makeRequest,
    results: readonly(results),
    error: readonly(error),
  };
}
